import React from 'react'
import CountProjects from '../../shared/CountProjects'
import ProjectAvatar from '../../shared/ProjectAvatar'

type MilestonesCardProps = {
    total: number;
    info: string;
    isLoan?: boolean;
    isTcp?: boolean;
    isIgr?: boolean;
    lonValue?: number;
    tcpValue?: number;
    igrValue?: number;
    containerClassName?: string;
    innerStyle?: React.CSSProperties;
    avatarsWrapperClassName?: string;
    avatarsWrapperStyle?: React.CSSProperties;
}


const MilestoneCard: React.FC<MilestonesCardProps> = ({
    total,
    info,
    isLoan,
    isTcp,
    isIgr,
    lonValue,
    tcpValue,
    igrValue,
    containerClassName = 'card-project-milestones',
    innerStyle = { margin: '2rem' },
    avatarsWrapperClassName = 'c-content project-avatar',
    avatarsWrapperStyle = { marginTop: '1rem' },
}) => {
    return (
        <section className={containerClassName}>
            <div style={innerStyle}>
                <CountProjects total={total} info={info} />
                <div className={avatarsWrapperClassName} style={avatarsWrapperStyle}>
                    {isLoan && (
                        <ProjectAvatar label="LON" value={lonValue ?? 0} className="avatar-style-lon" />
                    )}
                    {isTcp && (
                        <ProjectAvatar label="TCP" value={tcpValue ?? 0} className="avatar-style-tcp" />
                    )}
                    {isIgr && (
                        <ProjectAvatar label="IGR" value={igrValue ?? 0} className="avatar-style-igr" />
                    )}
                </div>
            </div>
        </section>
    )
}

export default MilestoneCard